/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { connect } from 'react-redux';
import { Query } from 'react-apollo';
import mbpLogger from 'mbp-logger';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import {
    object, arrayOf, string,
} from 'prop-types';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import findSkuByPartNumbers from '../../../../../../../../../gql/queries/findSkuByPartNumbers';
import { GRAPHQL_ENV } from '../../../../../../../../../gql';
import { getCartError } from '../../../../../../../../../../state/ducks/Checkout/ducks/Common/Common-Selectors';
import UpSellProductList from '../UpSellProductList/UpSellProductList';
import ErrorMessage from '../../../ErrorMessage/ErrorMessage';

const styles = ({ palette }) => ({
    recommendationContent: {
        backgroundColor: (palette.modalBg || '#f2f2f2'),
        borderTop: `1px solid ${(palette.colorDisabled || '#ccc')}`,
        overflowX: 'hidden',
    },
    recommendationBorder: {
        padding: '6px 15px',
        '& .slick-prev': {
            margin: '44px 0px',
        },
        '& .slick-next': {
            margin: '44px 0px',
        },
    },
    textCenter: {
        textAlign: 'center',
    },
    recommendationContainer: {
        padding: '0px 40px',
        width: '100%',
        '& img': {
            width: '100px',
            height: '100%',
            border: `1px solid ${(palette.text?.primary || '#2F2F2F')}`,
        },
        '& .slick-slider': {
            margin: '15px 0px 10px 0px',
            width: '100%',
            '& .slick-slide': {
                minWidth: '400px',
                marginRight: '10px',
                paddingRight: '0px',
                '&:not(:last-child)': {
                    borderRight: `1px solid ${palette.grey5 || '#909090'}`,
                },
            },
        },
        '& .slick-track': {
            display: 'flex',
            minWidth: '100%',
        },
        '& .carousel-container': {
            display: 'flex',
        },
        '& .slick-list': {
            width: '95%',
            overflow: 'hidden',
        },
    },
});

const getSalePrice = (productPrice) => productPrice?.filter((price) => price?.type === 'sale')[0];

const getMinimumSalePrice = (upSellProducts) => (upSellProducts.map((product) => {
    const price = getSalePrice(product?.prices);
    return price?.value || 0;
}).reduce((minPrice, price) => (price < minPrice ? price : minPrice)));

const UpSellProducts = ({
    classes,
    partNumbers,
    brand,
    cartError,
}) => {
    if (!partNumbers || partNumbers.length < 1) return null;

    const arrPartNumbers = `["${partNumbers.join('","')}"]`;
    const QUERY = findSkuByPartNumbers(
        brand.domain,
        arrPartNumbers,
        `brand
        brandId
        id
        partNumber
        name
        prices {
            currency
            type
            value
        }
        image {
            name
            path
        }
        parentProduct {
            seo {
              url
            } 
        }`,
    );
    return (
        <Query query={QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return null;
                }

                if (error) {
                    mbpLogger.logError({
                        query: QUERY,
                        component: 'UpSellProductsBuilder.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                    return null;
                }

                if (!data) {
                    mbpLogger.logWarning({
                        query: QUERY,
                        component: 'UpSellProductsBuilder.js',
                        message: 'No data returned for query',
                        env: GRAPHQL_ENV,
                    });
                    return null;
                }
                let upSellProducts = null;
                if (data.findSkuByPartNumbers) {
                    upSellProducts = data.findSkuByPartNumbers;
                }

                let minUpsellValue = 0;
                if (upSellProducts.length) {
                    minUpsellValue = getMinimumSalePrice(upSellProducts);
                }

                return (
                    <>
                        {(upSellProducts.length > 0)
                            && (
                                <>
                                    {cartError && <ErrorMessage error={cartError} noShadow align="center" />}
                                    <DialogContent className={classes.recommendationContent}>
                                        <Grid container className={classes.recommendationContainer}>
                                            <Grid item sm={12} md={12} className={`${classes.recommendationBorder} ${classes.textCenter}`}>
                                                <Typography variant="body2">
                                                    <b>Get something for yourself! Starting at {`$${minUpsellValue}`}</b>
                                                </Typography>
                                            </Grid>
                                            <Grid item sm={12} md={12} className={classes.recommendationBorder}>
                                                <div>
                                                    <UpSellProductList
                                                        product={upSellProducts}
                                                    />
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </DialogContent>
                                </>
                            )}
                    </>
                );
            }}
        </Query>
    );
};

UpSellProducts.propTypes = {
    brand: object.isRequired,
    classes: object.isRequired,
    partNumbers: arrayOf(string).isRequired,
    cartError: string.isRequired,
};

UpSellProducts.propTypes = {
    brand: object.isRequired,
};

const mapStateToProps = (state) => ({
    cartError: getCartError(state),
});

export default connect(mapStateToProps)(withStyles(styles)(UpSellProducts));
